import { useState, useEffect } from 'react';

export const useEnableHeaderFooterBorder = (modalBodyRef) => {
  const [hasOverflow, setHasOverflow] = useState(false);

  const checkOverflow = () => {
    if (modalBodyRef?.current) {
      const { clientHeight } = modalBodyRef?.current;
      setHasOverflow(clientHeight > 500);
    }
  };

  useEffect(() => {
    checkOverflow();
    window.addEventListener('resize', checkOverflow);
    return () => window.removeEventListener('resize', checkOverflow);
    //eslint-disable-next-line
  }, [modalBodyRef?.current?.clientHeight]);

  return { hasOverflow };
};
